import { EventTypes } from 'src/app/common/shared/observer.enum';
import { Observer } from 'src/app/common/shared/observer.interface';
import { Subject } from 'src/app/common/shared/subject.model';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';

export class ContactUsSubject extends Subject {
  public notify(event: EventTypes, data: FormConstructorContent): void {
    this.observers.forEach((observer: Observer) => observer.update(event, data));
  }
}
